import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK = ['North Indian', 'South Indian', 'Chinese', 'Continental', 'Snacks & Fast Food', 'Beverages',
  'Desserts & Sweets', 'Combos & Meals', 'Healthy', 'Add-ons & Extras', 'Other'];

export const useFoodCategories = () => {
  const [cats, setCats] = useState(FALLBACK);
  useEffect(() => {
    axios.get(`${API}/food-categories`, { withCredentials: true })
      .then(({ data }) => { if (Array.isArray(data) && data.length) setCats(data.map((c) => c.name)); })
      .catch(() => {});
  }, []);
  return cats;
};
